import { render, staticRenderFns } from "./CardValidaDocuments.vue?vue&type=template&id=cacab064"
import script from "./CardValidaDocuments.vue?vue&type=script&lang=js"
export * from "./CardValidaDocuments.vue?vue&type=script&lang=js"
import style0 from "./CardValidaDocuments.vue?vue&type=style&index=0&id=cacab064&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cacab064')) {
      api.createRecord('cacab064', component.options)
    } else {
      api.reload('cacab064', component.options)
    }
    module.hot.accept("./CardValidaDocuments.vue?vue&type=template&id=cacab064", function () {
      api.rerender('cacab064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingDetailPerson/components/CardValidaDocuments.vue"
export default component.exports